import React, {useState, useEffect} from "react";
import classes from './StartKYC.module.scss'
import axios from "axios";
import { connect } from "react-redux";
import {setIDKYC, setIdentificationStatus, setErrorStatus} from '../../bll/AuthReducer'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StartKYC = (props :any) => {

    let id :any
    let url :any
    const envKycId :any = process.env.REACT_APP_KYC_ID

    // useEffect(() => {
    //     // console.log('custom id', props.data)
                
    //     if(props.data.idKYC) { //если есть айдишник ондаты
    //         const interval = setInterval(() => {
    //             console.log('component start kyc',props.data);
    //             if(props.data.identificationStatus !== 'APPROVED' || props.data.identificationStatus !== 'FAILED' || props.data.identificationStatus ===  ''){ // если счетчик меньше 60 или статус не апрув или фейлд
    //                 checkKYC()
    //             }
    //             else{ // остановка интервала
    //                 console.log('!!!!!!!!!!!!!!');
    //                 clearInterval(interval);
    //             }
    //         },3000) // каждые 30 секунд запуск
    //     }
    // },[props.data.idKYC])

    useEffect(() => {
        // console.log('mounting')
        if(props.data.idKYC) { //если есть айдишник ондаты
            // console.log('has id kyc')
           if(props.data.identificationStatus !== 'APPROVED' || props.data.identificationStatus !== 'FAILED') {
                // console.log('before launch timer')
                const interval = setInterval(() => {
                    // console.log('timer is turned on');
                    if(props.data.identificationStatus ===  '' || props.data.identificationStatus === 'PENDING' || props.data.identificationStatus === 'SUCCESSFUL'){ // если счетчик меньше 60 или статус не апрув или фейлд
                        // console.log('check status again');
                        checkKYC()
                    }
                    else{ // остановка интервала
                        // console.log('finish timer', props.data.identificationStatus)
                        clearInterval(interval);
                    }
                },60000) // каждые 30 секунд запуск
           }
        }
    },[props.data.idKYC])


    const sendKycIdToBackend = async () => {
        const token: any = localStorage.getItem('token')
        try{
            const request = await axios.post(`https://land.cpay.bar/user/personalIdentityId`, 
            {
                "personalIdentityId" : id
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization" : token
                }
            }
            )
            openPopup()
        }
        catch(e:any){
            console.log('status',e.response.status)
            if(e.response.status === 403){
                toast.error('Session has ended. Log in again')
            }
            else{
                toast.error('Something went wrong')
            }
        }
    }

    const beginKYCprocess = async () => {
        // console.log('here')
        try{
            const request = await axios.post("identifications/start", 
            {
                "flowData": {
                    "language": "en"
                },
            }, 
            {headers: {'x-api-key': envKycId, "Content-Type": "application/json", "Access-Control-Allow-Origin" : "*", "Access-Control-Allow-Headers" : "Origin, X-Requested-With, Content-Type, Accept"}})
            id = request.data.identificationId
            url = request.data.redirectUrl
            // console.log('here',id, 'redirect', request.data.redirectUrl)
            props.setIDKYC(id)
            sendKycIdToBackend()
        } 
        catch(e:any){
            console.log(e)
        }
    }

    const openPopup = () => {
        window.open(url, 'Popup', 'width = 1000, height = 800')
    }

    const checkKYC = async () => {
        // console.log('check id', props.data.idKYC)
        // console.log('start check kyc status inside func')
        const idKYC = 'c16eb5ed97774db5821f305628a83af3'

        // 979f9a3d8fed4423b6d178faa871c60c success
        // c16eb5ed97774db5821f305628a83af3 failed
        // c5c8169cc73f43d09b3219bd46ff1e77 empty

        //props.data.idKYC
        try{
            // const request = await axios.get(`identifications/${idKYC}/data`, 
            const request = await axios.get(`identifications/${props.data.idKYC}/data`, 
            {
                headers: {
                'x-api-key': envKycId, 
                "Content-Type": "application/json", 
                "Access-Control-Allow-Origin" : "*", 
                "Access-Control-Allow-Headers" : "Origin, X-Requested-With, Content-Type, Accept"}
                }
            )
            // console.log('status kyc', request.data.identificationData.status)
            // console.log('status error', request.data.identificationData.failReason)
            props.setIdentificationStatus(request.data.identificationData.status)
            props.setErrorStatus(request.data.identificationData.failReason)
        }
        catch(e :any){
            console.log('here failed', e.response.data.status)
        }
    }

    return ( 
        props.data.identificationStatus ? 
            props.data.identificationStatus === 'APPROVED' ?
                <div className={classes.start}/>
            :
            props.data.identificationStatus === 'PENDING' ? 
                <div className={classes.start}>
                    <div className={classes.start__wrapper}>
                        <p className={classes.start__wrapper_title}>Please waiting</p>
                        <p className={classes.start__wrapper_descr}>We are checking you data. It will take several minutes</p>
                    </div>
                </div>
                :
                <div className={classes.start}>
                    <div className={classes.start__wrapper}>
                        <p className={classes.start__wrapper_title}>Failed verification</p>
                        <p className={classes.start__wrapper_descr}>Code is {props.data.errorStatus}. You have to pass it to buy Cpay tokens</p>
                        <button className={classes.start__wrapper_btn} onClick={beginKYCprocess}>Pass the KYC</button>
                    </div>
                </div>
        :
        <div className={classes.start}>
            <div className={classes.start__wrapper}>
                <p className={classes.start__wrapper_title}>Unverified account</p>
                <p className={classes.start__wrapper_descr}>Please go through KYC following the instructions after clicking on the button, as you cannot make any payment transactions yet.</p>
                <button className={classes.start__wrapper_btn} onClick={beginKYCprocess}>Pass the KYC</button>
                {/* <button className={classes.start__wrapper_btn} onClick={checkKYC}>check status</button> */}
            </div>
            <ToastContainer 
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"/>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    data: state.AuthReducer,
})
  
export default connect(mapStateToProps, {setIDKYC, setIdentificationStatus, setErrorStatus})(StartKYC)